"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { getFullNameForLocator } from '@membranehq/sdk';
import { SvgIconType } from '../../../SvgIcon/svg-icon-type.mjs';
import { ComboBox } from '../../../ComboBox/ComboBox.mjs';
import '../../../DataBuilderUI/FieldControlPanel/index.mjs';
import '../../../DataBuilderUI/ActionBar.mjs';
import { Cell } from '../../../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../../../DataBuilderUI/styles.module.css.mjs';
import { Row } from '../../../DataBuilderUI/Row.mjs';
import '../../../DataBuilderUI/Title.mjs';
import { TagPlaceholder } from '../../../Tag/TagPlaceholder.mjs';
import { isObjectAllowedAdditionalProperties, fieldLabel } from '../../data-field.mjs';

function AddingFieldSelector({
  parentField,
  fieldsToAdd,
  onChange,
  onClose
}) {
  const allowAdditionalProperties = isObjectAllowedAdditionalProperties(parentField);
  const options = fieldsToAdd.map((f) => ({
    value: f.key,
    label: getFullNameForLocator(parentField.schema, f.key) || fieldLabel(f)
  }));
  if (allowAdditionalProperties) {
    options.unshift({
      value: "",
      label: "Add custom field",
      iconType: SvgIconType.Add
    });
  }
  return /* @__PURE__ */ jsxs(Row, { children: [
    /* @__PURE__ */ jsx(Cell, { type: "combobox", children: /* @__PURE__ */ jsx(
      ComboBox,
      {
        value: void 0,
        options,
        schema: {
          type: "string",
          allowCustom: allowAdditionalProperties
        },
        onChange,
        onClose,
        autoOpen: true
      }
    ) }),
    /* @__PURE__ */ jsx(Cell, { type: "combobox", span: "grow", disabled: true, children: /* @__PURE__ */ jsx(TagPlaceholder, { children: "Select value" }) })
  ] });
}

export { AddingFieldSelector };
